import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle } = FiIcons;

export default function SectionLandscape({ landscapeTitle, landscapeText, solutionsTitle, solutions }) {
  return (
    <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 mb-24 items-start">
      {/* Landscape Context */}
      <div className="lg:col-span-5 pt-4">
        <h3 className="text-2xl md:text-3xl font-semibold text-deepNavy mb-6 leading-snug">
          {landscapeTitle}
        </h3>
        <p className="text-deepNavy-lighter leading-relaxed text-lg font-light">
          {landscapeText}
        </p>
      </div>

      {/* Solutions List */}
      <div className="lg:col-span-7 bg-white rounded-3xl p-8 md:p-12 shadow-apple border border-gray-100 transition-shadow duration-300 hover:shadow-apple-hover">
        <h3 className="text-2xl font-semibold text-deepNavy mb-8 pb-6 border-b border-gray-100">
          {solutionsTitle}
        </h3>
        <ul className="space-y-8">
          {solutions.map((solution, idx) => (
            <li key={idx} className="flex items-start group">
              <div className="flex-shrink-0 mt-1">
                <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-sage transition-transform duration-300 group-hover:scale-110" />
              </div>
              <div className="ml-5">
                <h4 className="text-lg font-semibold text-deepNavy mb-2">
                  {solution.title}
                </h4>
                <p className="text-deepNavy-lighter leading-relaxed font-light">
                  {solution.desc}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}